import React from "react";

const Java_Square_Root = () => {
  return (
    <div>
      <h1>Java Square Root</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Square Root in Java.</p>
    </div>
  );
};

export default Java_Square_Root;
